import { ReactNode } from "react";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Icon } from "../../icon/icon";

export const FindEventsFilterModal = ({
  open,
  handleClose,
  children,
  title,
}: ModalCompProps & {
  children: ReactNode;
  title: string;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
      showMobileTopBar={false}
    >
      <div className="flex flex-col gap-3">
        <div className="flex items-start justify-between gap-[10px]">
          <p className="text-dark-blue-500 text-base font-bold">{title}</p>

          <button
            type="button"
            className="w-fit"
            onClick={() => {
              handleClose();
            }}
          >
            <Icon
              svg={"close-icon"}
              width={24}
              height={24}
              className="text-grey-600"
            />
          </button>
        </div>

        {children}
      </div>
    </ModalComponent>
  );
};
